// extracted by mini-css-extract-plugin
module.exports = {"menuName":"menu-module--menu-name--MmGoF","menuLink":"menu-module--menu-link--2g57I"};